import { z } from "zod"

import { casNumberSchema } from "@/utils/validation/casNumberValidation"

export const AddProductRegulatorySchema = z.object({
  casRegistryIds: z
    .array(z.union([z.literal(""), z.undefined(), casNumberSchema]))
    .max(10)
    .default([])
    .refine((casNumbers) => {
      return casNumbers.length === 0 || casNumbers.some((cas) => cas && cas.trim() !== "")
    }, "At least one valid CAS Registry ID is required"),
  unNumber: z.union([z.literal(""), z.string().regex(/^\d{4}$/, "UN Number must be exactly 4 digits")]).optional(),
  isRohsCompliant: z.boolean().optional(),
  isReachSvhcCompliant: z.boolean().optional(),
})
